import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { SentryErrorBoundary } from '@paragon/client-tools';
import { ParagonThemeProvider } from '@paragon/themes';

import { store } from '../store';
import { darkTheme, lightTheme } from '../themes';
import { RootComponent } from './RootComponent';

interface Props {
  readonly reduxStore: typeof store;
}

export default function UserAccountManagementClient(props: Props) {
  return (
    <React.StrictMode>
      <SentryErrorBoundary>
        <BrowserRouter>
          <Provider store={props.reduxStore}>
            <ParagonThemeProvider darkTheme={darkTheme} lightTheme={lightTheme}>
              <RootComponent />
            </ParagonThemeProvider>
          </Provider>
        </BrowserRouter>
      </SentryErrorBoundary>
    </React.StrictMode>
  );
}
